import FileUpload from 'common/components/FileUpload';
import InputFeedback from 'components/common/form/InputFeedback';
import React, { useEffect } from 'react';
import { useState } from 'react';

import './logoInput.css';

const base64ToArrayBuffer = function (base64) {
  var binaryString = window.atob(base64);
  var len = binaryString.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

const LogoInput = ({
  value,
  onChange,
  validationRules,
  translator: t = (key, params) => key }) => {

  const [logoBase64, setLogoBase64] = useState(value);
  const [logoProperties, setLogoProperties] = useState({});
  const [logoValidationErrors, setLogoValidationErrors] = useState([]);

  const handleLogoChange = (e) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    }).then(base64 => {
      setLogoBase64(base64);
      onChange({ logo: base64, logoFilename: e.target.files[0].name });
    });
  };

  const validateLogo = ({ imageProperties, rules = {}, translator: t }) => {
    if (!imageProperties) {
      return [];
    }

    return Object.entries(rules)
      .filter(([_, criteria]) => !criteria.checker(imageProperties, criteria.criteria))
      .map(([key, criteria]) => t(`validationErrors.logo.${key}`, { ...criteria.criteria, ...imageProperties }));
  };

  useEffect(() => {
    const img = new Image();

    img.onload = function (e) {
      // eslint-disable-next-line no-magic-numbers
      const sizeInKib = Math.round(base64ToArrayBuffer(logoBase64.split(',')[1]).byteLength / 1024);

      const props = { sizeInKib, width: img.width, height: img.height, aspectRatio: img.height / img.width };
      setLogoProperties(props);
      setLogoValidationErrors(validateLogo({ imageProperties: props, rules: validationRules, translator: t }));
    };

    img.src = logoBase64;
  }, [logoBase64]);

  return <>
    <p>
      {t('description.main')}
    </p>

    <p>
      {t('description.requirements')}
      <ul id="logo-requirements">
        {Object.entries(validationRules).map(([k, v]) => <li>{t(`description.criteria.${k}`, { ...logoProperties, ...v.criteria })}</li>)}
      </ul>
    </p>

    <FileUpload
      name="logo"
      buttonStyles={{ backgroundColor: '#e9ecef', color: '#000' }}
      onChange={handleLogoChange}
      accept="image/png"
      chooseFileLabel={t('labels.chooseLogo')}
      noFileChosenLabel={t(`${logoBase64 ? 'labels.existingLogo' : 'labels.noLogoChosen'}`)}
    />

    {logoValidationErrors.length > 0 && <div style={{ marginTop: '1rem' }}>
      <InputFeedback>
        <p>{t('validationErrors.logo.general')}.<br />{t('validationErrors.logo.fix')}:<br />
          <ul id="logo-validation-errors">
            {logoValidationErrors.map(error => <li>{error}</li>)}
          </ul>
        </p>
      </InputFeedback>
    </div>
    }
  </>;
};

export default LogoInput;
